import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FavoritesChannelsComponent } from './components/favorites-channels/favorites-channels.component';
import { FavoritesClubsComponent } from './components/favorites-clubs/favorites-clubs.component';
import { FavoritesOutletComponent } from './components/favorites-outlet/favorites-outlet.component';
import { FavoritesProductsComponent } from './components/favorites-products/favorites-products.component';
import { FavoritesRecipesComponent } from './components/favorites-recipes/favorites-recipes.component';
import { FavoritesStreamsComponent } from './components/favorites-streams/favorites-streams.component';
import { FavoritesUpcomingComponent } from './components/favorites-upcoming/favorites-upcoming.component';

const routes: Routes = [
  {
    path: '',
    component: FavoritesOutletComponent,
    children: [
      { path: '', redirectTo: 'upcoming', pathMatch: 'full' },
      { path: 'upcoming', component: FavoritesUpcomingComponent },
      { path: 'channels', component: FavoritesChannelsComponent },
      { path: 'streams', component: FavoritesStreamsComponent },
      { path: 'recipes', component: FavoritesRecipesComponent },
      { path: 'clubs', component: FavoritesClubsComponent },
      { path: 'products', component: FavoritesProductsComponent },
      { path: 'recipe', redirectTo: 'recipes' },
    ],
  },
  { path: ':id', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyFavoritesRoutingModule {}
